function initInfiniteCollectionScroll() {
   const masterWrapperClass = ".ProductListWrapper";
   let masterWrapper = document.querySelector(masterWrapperClass);

   function getTotalPages() {
      return Number(masterWrapper?.getAttribute("data-total-pages"));
   }

   function getRerenderedAttr() {
      return !!document
         .querySelector(masterWrapperClass)
         ?.getAttribute("data-rerendered");
   }

   masterWrapper.removeAttribute("data-rerendered");

   let total_pages = getTotalPages();
   if (isNaN(total_pages) || total_pages <= 1) return;

   let currentPage = 1;
   let loading = false;
   const pathname = window.location.pathname;

   const wrapperClass = ".ProductListWrapper .ProductList.ProductList--grid";
   let wrapper = document.querySelector(wrapperClass);

   if (!wrapper) return;

   window.addEventListener("scroll", () => {
      if (getRerenderedAttr()) {
         masterWrapper = document.querySelector(masterWrapperClass);
         wrapper = document.querySelector(wrapperClass);
         total_pages = getTotalPages();
        masterWrapper.removeAttribute("data-rerendered");
         currentPage = 1;
      }
      if (
         wrapper.getBoundingClientRect().bottom < window.innerHeight + 100 &&
         !loading &&
         currentPage < total_pages
      ) {
         loading = true;
         currentPage++;
         const params = new URLSearchParams(window.location.search);
         params.set("page", currentPage);
         const url = pathname + "?" + params.toString();
         document.querySelector(".loading-indicator")?.classList.add("--active");

         fetch(url)
            .then((res) => res.text())
            .then((text) => {
               const fetchedDom = new DOMParser().parseFromString(text, "text/html");
               const productCards = fetchedDom.querySelectorAll(
                  wrapperClass + " .Grid__Cell"
               );

               for (let i = 0; i < productCards.length; i++) {
                  const card = productCards[i];
                  card
                     .querySelector(".ProductItem")
                     ?.setAttribute(
                        "style",
                        "visibility: inherit; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                     );
                  wrapper.appendChild(productCards[i]);
               }

               loading = false;
               document
                  .querySelector(".loading-indicator")
                  ?.classList.remove("--active");

               function removeDuplicates(tag) {
                  const uniqueBlockContents = [];
                  document.querySelectorAll(tag).forEach(function (el) {
                     const content = el.innerHTML
                     if (!uniqueBlockContents.hasOwnProperty(content)) {
                        uniqueBlockContents[content] = true;
                     } else {
                        el.remove();
                     }
                  })
               }

               removeDuplicates('#section-featured-highlights')
               removeDuplicates('#image-with-button')

            });
      }
   });
}

initInfiniteCollectionScroll();

